import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { usePageTracking } from './hooks/usePageTracking';
import Dashboard from './pages/Dashboard';
import Landing from './pages/Landing';
import IztacalcoInfographic from './pages/IztacalcoInfographic';
import Suppliers from './pages/Suppliers';
import VibeCoding from './pages/VibeCoding';

import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Inner component to use hook inside Router context
function AppContent() {
  usePageTracking();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/vibe-coding" element={<VibeCoding />} />
      <Route path="/app" element={<Dashboard />} />
      <Route path="/proveedores" element={<Suppliers />} />
      <Route path="/iztacalco" element={<IztacalcoInfographic />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/aviso-privacidad" element={<PrivacyPolicy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

